/**
 * Time formatting shared by the attempt chrome and the report.
 *
 * Separate from `copy.ts` because these are not sentences to be rewritten — they
 * are the same clock in two places, and the report's evidence timestamps have to
 * match the countdown the learner was watching while speaking.
 */

export function formatClock(seconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  return `${String(Math.floor(safeSeconds / 60)).padStart(2, "0")}:${String(
    safeSeconds % 60
  ).padStart(2, "0")}`;
}

export function formatTimestamp(milliseconds: number): string {
  return formatClock(milliseconds / 1_000);
}
